import * as React from 'react'
import { NumberFieldSeeker } from '@ui-seeker/core'

import { AppAntSwitch } from '@components'
import { isPreviousComparison, timeToCompare, yearlyComp } from '@signals'
import { Grid } from '@mui/material'


export default function AppCommonFiltersPeriodCompareToggleButton({ ...props }) {
	return <Grid container spacing={2}>
		<Grid item>
			<AppAntSwitch
				trueText="Compare with other period"
				checked={isPreviousComparison.value}
				onChange={e => {
					isPreviousComparison.value = e.target.checked
					if (!e.target.checked) {
						timeToCompare.value = ""
					}
				}}
				{...props}
			/>
		</Grid>
		<Grid item>
			{isPreviousComparison.value && <AppAntSwitch
				trueText="Number of years"
				falseText="Number of days"
				checked={yearlyComp.value}
				onChange={e => yearlyComp.value = e.target.checked}
				{...props}
			/>}
		</Grid>
	</Grid>
}

export function AppCommonFiltersPeriodCompareInput({ ...props }) {
	return isPreviousComparison.value && <NumberFieldSeeker
		value={timeToCompare.value}
		onChange={e => timeToCompare.value = e.target.value}
		label="Days/Years compare"
		{...props}
	/>
}